export function toMp3FallbackPath(oggPath: string): string {
  if (!oggPath.startsWith("/audio/") || !oggPath.endsWith(".ogg")) {
    throw new Error("Expected a local OGG audio path: " + oggPath);
  }

  return oggPath.slice(0, -4) + ".mp3";
}
